import { LandingPage } from '../LandingPage';
import { salonsConfig } from './config';

export default function SalonsLandingPage() {
  return <LandingPage config={salonsConfig} />;
}
